import React from 'react';
import PropTypes from 'prop-types';
import { ContentGrouping } from '../../core/ContentGrouping';
import { GeneralList } from '../../core/GeneralList';
import { API_STRATEGY_DOWNLOAD } from '../../../constants/api';

const Strategy = ({ dataList, title, defaultTextForNow }) => (
  <ContentGrouping titleWithBorder title={title}>
    <GeneralList
      dataList={dataList}
      defaultTextForNow={defaultTextForNow}
      apiGeneralList={API_STRATEGY_DOWNLOAD}
    />
  </ContentGrouping>
);

Strategy.propTypes = {
  dataList: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string,
      href: PropTypes.string
    })
  ),
  title: PropTypes.string
};

export default Strategy;
